import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  // 获取默认音乐
  GetMusicInfoManageDefaultMusic({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MusicInfoManage/GetDefaultMusic",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 获取系统音乐集合
  GetMusicInfoManageMusicInfoList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MusicInfoManage/GetMusicInfoList",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 设置纪念馆音乐
  updateMusicInfoManageAddMusicRelationVue({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/MusicInfoManage/AddMusicRelationVue",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
